import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  dispatchEvent({ target = this.element, action, options = {} }) {
    const mergedOptions = { ...this.dispatchEventDefaultOptions, ...options }
    target.dispatchEvent(new CustomEvent(`${this.identifier}:${action}`, mergedOptions))
  }

  get dispatchEventDefaultOptions() {
    return {
      bubbles: true,
      cancelable: true
    }
  }
}
